export const qtiLoginConstants = {
  QTI_LOGIN_LOADING: "QTI_LOGIN_LOADING",
  QTI_LOGIN_SUCCESS: "QTI_LOGIN_SUCCESS",
  QTI_LOGIN_ERROR: "QTI_LOGIN_ERROR"
}
